import { create } from 'zustand';
import { adminUserApi } from '@api/api-config.ts';
import { AdminUserDetailResponse, AdminUserUpdateRequest } from '@api/generated/portal-be-admin';

interface AdminUserDetailStoreState {
  loading: boolean;
  error: string | null;
  user: AdminUserDetailResponse | null;

  loadUserDetail: (userId: number) => Promise<void>;
  /** Uloží kmenové údaje a rovnou přenačte detail. Vrací chybu k zobrazení, nebo null při úspěchu. */
  updateUser: (userId: number, request: AdminUserUpdateRequest) => Promise<string | null>;
  clearUser: () => void;
}

export const useCreateAdminUserDetailStore = create<AdminUserDetailStoreState>(set => ({
  loading: false,
  error: null,
  user: null,

  loadUserDetail: async (userId: number) => {
    try {
      set({ loading: true, error: null });

      const response = await adminUserApi.getUserDetail({ userId });

      set({ loading: false, user: response.data });
    } catch (error) {
      set({ loading: false, error: error instanceof Error ? error.message : 'Chyba při načítání detailu uživatele' });
    }
  },

  updateUser: async (userId: number, request: AdminUserUpdateRequest) => {
    try {
      await adminUserApi.updateUser({ userId, adminUserUpdateRequest: request });
      await useCreateAdminUserDetailStore.getState().loadUserDetail(userId);
      return null;
    } catch (e: any) {
      // BE vrací 409 s hláškou u kolize e-mailu - ať se uživatel dozví proč to neprošlo
      return e.response?.data?.message || e.message || 'Uživatele se nepodařilo uložit';
    }
  },

  clearUser: () => {
    set({ user: null, error: null });
  },
}));
